let sliderInstances = [];

function initMobileLogoSlider() {
  const containers = document.querySelectorAll('.logo_slider_title .group-block.logo_list .layout-panel-flex--row');

  containers.forEach((container, index) => {
    // Prevent double-init
    if (container.classList.contains('swiper')) return;

    // Add swiper container class
    container.classList.add('swiper');

    // Create wrapper
    const wrapper = document.createElement('div');
    wrapper.classList.add('swiper-wrapper');

    // Move ONLY real elements
    Array.from(container.children).forEach(child => {
      child.classList.add('swiper-slide');
      wrapper.appendChild(child);
    });

    container.appendChild(wrapper);

    // Create nav group (arrows below slider)
    const navWrapper = document.createElement('div');
    navWrapper.className = 'swiper-nav';

    const prevBtn = document.createElement('div');
    prevBtn.className = `swiper-button-prev swiper-button-prev-${index}`;

    const nextBtn = document.createElement('div');
    nextBtn.className = `swiper-button-next swiper-button-next-${index}`;

    navWrapper.appendChild(prevBtn);
    navWrapper.appendChild(nextBtn);

    // Insert navigation directly after slider container
    if (container.parentNode) {
      container.parentNode.insertBefore(navWrapper, container.nextSibling);
    }

    // Init Swiper with navigation
    const swiper = new Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      grabCursor: true,
      navigation: {
        nextEl: `.swiper-button-next-${index}`,
        prevEl: `.swiper-button-prev-${index}`,
      },
    });

    // Remove incompatible ARIA roles from interactive elements
    // Swiper may add role="group" to slides, but this is invalid on <a> and <button> elements
    const slides = container.querySelectorAll('.swiper-slide');
    slides.forEach(slide => {
      // Find interactive elements within the slide
      const interactiveElements = slide.querySelectorAll('a, button, [role="button"], [role="link"]');
      interactiveElements.forEach(el => {
        // Remove role="group" if present (incompatible with interactive elements)
        if (el.getAttribute('role') === 'group') {
          el.removeAttribute('role');
        }
      });
      // Also check the slide itself if it's an interactive element
      if (slide.matches('a, button, [role="button"], [role="link"]')) {
        if (slide.getAttribute('role') === 'group') {
          slide.removeAttribute('role');
        }
      }
    });

    // Store instance
    sliderInstances.push({ container, wrapper, navWrapper, swiper });
  });
}

function destroyMobileLogoSlider() {
  sliderInstances.forEach(({ container, wrapper, navWrapper, swiper }) => {

    // ✅ Keep inline desktop layout styles (important)
    swiper.destroy(false, false);

    // Remove swiper class only
    container.classList.remove('swiper');

    // Unwrap children back out — but do NOT touch inline styles
    Array.from(wrapper.children).forEach(slide => {
      slide.classList.remove('swiper-slide');
      container.appendChild(slide);
    });

    wrapper.remove();    // remove wrapper
    navWrapper.remove(); // remove arrows container
  });

  sliderInstances = [];
}

function checkViewportForSlider() {
  if (window.matchMedia("(max-width: 989px)").matches) {
    initMobileLogoSlider();
  } else {
    destroyMobileLogoSlider();
  }
}

checkViewportForSlider();
window.addEventListener('resize', checkViewportForSlider);
